module.exports = __webpack_public_path__ + "static/img/twjd-sdd1.cbf4e3a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdd1.png
// module id = 835
// module chunks = 0